const luhn = require('fast-luhn')
const personnummerValidator = require('./is-my-svenskt-personnummer-valid')()

/**
 * maybeCentury: matches[1]
 * maybeDate: matches[2]
 * groupNumber: matches[3]
 * maybeMonth: matches[4]
 * digits: matches[5]
 * check: matches[6]
 **/
const FORMAT = /^(\d{2})((\d{1})\d{1}(\d{2})\d{2})(\d{3})(\d{1})$/

const groupNumbers = new Map([
  ['1', 'Dödsbon'],
  ['2', 'Stat, landsting, kommuner, församlingar'],
  ['3', 'Utländska företag som bedriver näringsverksamhet eller äger fastigheter i Sverige'],
  ['5', 'Aktiebolag'],
  ['6', 'Enkelt bolag'],
  ['7', 'Ekonomiska föreningar, bostadsrättsföreningar'],
  ['8', 'Ideella föreningar och stiftelser'],
  ['9', 'Handelsbolag, kommanditbolag och enkla bolag'],
])

module.exports = function(opts = {}) {
  const acceptedGroupNumbers = opts.acceptedGroupNumbers || Array.from(groupNumbers.keys())

  return value => {
    if (!value || !FORMAT.test(value)) return false

    const [, maybeCentury, maybeDate, groupNumber, maybeMonth, digits, check] = value.match(FORMAT)

    // This is a physical person and should be a valid personnummer
    if (maybeCentury !== '16') return personnummerValidator(value)

    // This is a legal person and should therefore have a "month" that is at least 20
    if (parseInt(maybeMonth, 10) < 20) return false

    if (!acceptedGroupNumbers.includes(groupNumber)) return false

    return luhn(`${maybeDate}${digits}${check}`)
  }
}
